import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'react-router-dom'

const PowerConsumptionNavLink = ({ path, children }) => (
  <NavLink to={path} className="nav-link" activeClassName="active">
    <span>{children}</span>
  </NavLink>
)

const paths = [
  '/power-consumption/all-amenities',
  '/power-consumption/electricity',
  '/power-consumption/gas',
  '/power-consumption/load-curve',
]

PowerConsumptionNavLink.propTypes = {
  path: PropTypes.oneOf(paths).isRequired,
  children: PropTypes.node.isRequired,
}

export default PowerConsumptionNavLink
